import { FormAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../../BaseController';
import { Inject } from '@odinjs/odin';
import { Value } from '@philips-internal/oswald-ui-core';

class EventListenerController {
  static fillSolutionDetailListener: EventListener | undefined;
}
interface SolutionDetail {
  [key: string]: string | number | Date | boolean | null | undefined;
  date: string;
  emarVolumeQuantity: string;
  partialVolumeQuantityBI: string;
  solutionDescription: string;
  unitMeasureCode: string;
}
@Controller({ fragment: 'infusion-solution-detail-step' })
class InfusionSolutionDetailController extends BaseController {

  @Inject('form-solution')
  formSolutionAPI!: FormAPI;

  private removeEventListener(): void {
    if (EventListenerController.fillSolutionDetailListener) {
      removeEventListener('fillSolutionDetail', EventListenerController.fillSolutionDetailListener);
      EventListenerController.fillSolutionDetailListener = undefined;
    }
  }

  addEventListener = (): void => {
    const {formSolutionAPI} = this;
    this.removeEventListener();
    addEventListener('fillSolutionDetail', (event) => this.fillSolutionDetailListener(event, formSolutionAPI), false);
  }

  fillSolutionDetailListener(e: Event, formSolutionAPI: FormAPI): void {
    const ce: CustomEvent = e as CustomEvent;
    const solutionDetail = ce.detail.solutionDetail as SolutionDetail;

    let volumeQuantity = '0';
    let partialVolumeQuantityBI = '0';

    if ( solutionDetail.emarVolumeQuantity ) {
      volumeQuantity = `${solutionDetail.emarVolumeQuantity} ${solutionDetail.unitMeasureCode}`
    }

    if ( solutionDetail.partialVolumeQuantityBI ) {
      partialVolumeQuantityBI = `${solutionDetail.partialVolumeQuantityBI} ${solutionDetail.unitMeasureCode}`
    }

    const solutionDetailView = {
      date: solutionDetail.date,
      emarVolumeQuantity: volumeQuantity,
      partialVolumeQuantityBI: partialVolumeQuantityBI,
      unitMeasureCode: solutionDetail.unitMeasureCode
    }

    formSolutionAPI.setData(solutionDetailView as Record<string, Value>);

  }

  @OnMount({ target: 'detail-infusion-step-layout' })
  onDetailInfusionStepLayout = (): void => {
    this.addEventListener();
  }

}

export default InfusionSolutionDetailController;